import React from "react";
import { Row, Col, Tooltip } from "antd";
import { Info } from "@material-ui/icons";
import { dirname } from "util/resourcePath";
import { file } from "jszip";

const directory = dirname();

export const additionalNote = {
  modal: {
    title: () => (
      <>
        Example CSV Format{"  "}
        <Tooltip
          overlayClassName="custom-tooltip-wide"
          title={
            <>
              <p
                className="custom-small-font"
                style={{ textIndent: "2em" }}
              >
                The CSV (Excel) file must contain the following columns:
              </p>
              <ul className="custom-small-font">
                <li>SF Project ID</li>
                <li>Month</li>
                <li>Custom Key 1</li>
              </ul>
              <p
                className="custom-small-font"
                style={{ textIndent: "2em" }}
              >
                Optional:
              </p>
              <ul className="custom-small-font">
                <li>Custom Key 2</li>
                <li>…</li>
              </ul>
              <p
                className="custom-small-font"
                style={{ textIndent: "2em" }}
              >
                Custom Key 1, Custom Key 2, and any additional custom
                columns represent the invoice notes that will be added
                dynamically to invoices. You may name these columns however
                you like, and you can include as many custom columns as
                needed.
              </p>
              <p
                className="custom-small-font"
                style={{ textIndent: "2em" }}
              >
                <b>
                  <u>Please ensure that this invoice is not approved</u>
                </b>
                , as notes cannot be updated once an invoice has been
                approved.
              </p>
            </>
          }
          placement="bottom"
        >
          <Info />
        </Tooltip>
      </>
    ),
    content: () => (
      <>
        <Row>
          <Col span={24} style={{ textAlign: "center" }}>
            <img
              src={`${directory}/images/upload_data_page/additional-note-csv-example.png`}
              alt="example-csv-format"
            />
          </Col>
        </Row>
        <Row style={{ marginTop: "15px" }}>
          <p
            className="custom-medium-font"
            style={{
              textIndent: "2em",
            }}
          >
            After uploading the file, the invoice will appear as shown below.
          </p>
        </Row>
        <Row>
          <Col span={24} style={{ textAlign: "center" }}>
            <img
              src={`${directory}/images/upload_data_page/additional-note-invoice-result-example.png`}
              alt="example-result-invoice"
              style={{ width: "70%" }}
            />
          </Col>
        </Row>
      </>
    ),
  },
  form: {
    title: "Additional Note For Invoice",
    description: "Upload a CSV file containing additional notes to be displayed in the top‑right corner of invoices. Currently, only Thailand (TH) invoices are supported.",
    upload: {
      uploadUrl: "/invoice/upload_additional_note",
      maxCount: 1,
      accept: ".csv",
      isInvalid: (file) => {
        // Check file extension
        const fileName = file.name.toLowerCase();
        const isCSV = fileName.endsWith(".csv");

        if (!isCSV) {
          return "You can only upload CSV files!";
        }

        // Check file type
        const isValidType =
          file.type === "text/csv" ||
          file.type === "application/vnd.ms-excel" ||
          file.type === "application/csv" ||
          file.type === "";

        if (!isValidType) {
          return "Invalid file type. Please upload a CSV file.";
        }

        // Check file size (5MB limit)
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
          return "File must be smaller than 5MB!";
        }
      }
    }
  }
}